import React from 'react'
import Main from '../../Layout/Main'
import Tittle from '../../Components/package/Tittle'
import Pricing from '../../Components/package/Pricing'

const Package = () => {
  return (
    <Main>
        <Tittle/>
        <Pricing/>
    </Main>
  )
}

export default Package